export default [
  'section-hero',
]
